import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Bulk update just the order field on a sortable content type
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestUpdateComponentContentOrder = packet => {
  return {
    type: 'REQUEST_UPDATE_COMPONENT_CONTENT_ORDER',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveUpdateComponentContentOrderSuccess = data => ({
  type: 'RECEIVE_UPDATE_COMPONENT_CONTENT_ORDER_SUCCESS',
  data
})

export const receiveUpdateComponentContentOrderFail = data => ({
  type: 'RECEIVE_UPDATE_COMPONENT_CONTENT_ORDER_FAIL',
  data
})

export const tryToUpdateComponentContentOrder = packet => (dispatch, getState) => {

  dispatch(requestUpdateComponentContentOrder(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/components/draft/content/order/' + packet.component_id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveUpdateComponentContentOrderSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveUpdateComponentContentOrderFail({errors:e, lastSubmit: packet}));
    })
}
